import { ITab } from '@/shared/Tabs/tabs.types.ts'

export type TMDMTab = 'primitives' | 'aggregates' | 'passports'

const mdmTabs: ITab<TMDMTab>[] = [
  { title: 'Примитивы', id: 'primitives' },
  { title: 'Агрегаты', id: 'aggregates' },
  { title: 'Паспорта', id: 'passports' },
]
export default mdmTabs
